import React, { useContext } from 'react';


export interface ReturnsPortalConfig {
  return_reasons?: string[],
}

const ReturnsPortalConfigContext = React.createContext({});
export const ReturnsPortalConfigProvider = ReturnsPortalConfigContext.Provider;
export function useReturnsPortalConfig(): ReturnsPortalConfig {
  const portalConfig = useContext(ReturnsPortalConfigContext) as ReturnsPortalConfig;

  return portalConfig;
}
